// sabitler.js
import {
    TenantService
} from './config/tenant';

export function baseURL() {
    return TenantService.getApiBaseUrl();
}

export const apiBaseURL = TenantService.getApiBaseUrl();
export const apiBase2URL = TenantService.getApiBaseUrl();